import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";

/*
*@author   tonicli
*@date     2017/5/10
*/
import { getUserAgent, globalObject } from "./system";
var env = {};
export function init(ua) {
  if (!ua) ua = getUserAgent();
  var isCSR = typeof __VUE_SSR_CONTEXT__ !== 'undefined';
  var isIphone = ua.indexOf('iPhone') >= 0;
  var isIpad = /(iPad).*OS\s([\d_]+)/.test(ua);
  var isIos = isIphone || isIpad;
  var isAndroid = ua.indexOf('Android') >= 0;
  var isApad = isAndroid && ua.indexOf('Mobile') < 0;
  var isMac = ua.indexOf('Macintosh') >= 0;
  var isWin = ua.indexOf('Windows') >= 0;
  var isMqq = /QQ\/([\d.]+)/.test(ua);
  var isWechat = ua.indexOf('MicroMessenger') >= 0 && ua.indexOf('wxwork') < 0;
  var isWeChatMiniProgramWebView = isCSR ? false : ua.indexOf('MicroMessenger') >= 0 && (globalObject.__wxjs_environment === 'miniprogram' || ua.match(/miniprogram/i));
  var isWeChatMiniProgram = typeof wx !== 'undefined' && wx.request || isWeChatMiniProgramWebView;
  var isApp = /(QQLive|WeTV)(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/i.test(ua);
  var isKidApp = ua.indexOf('QQLiveKidBrowser') >= 0;
  var isWetv = isApp && ua.indexOf('WeTVBrowser') >= 0;
  var isWeishi = /WEISHI_(\d+(\.\d+)*)/i.test(ua) || ua.indexOf('ilive') > -1;
  var isLiteApp = isApp && ua.indexOf('QQLiteBrowser') >= 0;
  var isBaseApp = ua.indexOf('QQLiveBrowser') >= 0 && !isLiteApp;
  var isLocalPkg = isApp && typeof location !== 'undefined' && !/^http(s)?:/.test(location.protocol);
  var isHDApp = ua.indexOf('QQLiveHDBrowser') >= 0 || isBaseApp && ua.indexOf('AppType/HD') >= 0;
  var isUNApp = isBaseApp && isIpad && (ua.indexOf('iPhone') >= 0 || ua.indexOf('AppType/UN') >= 0); // 与腾讯视频登录态打通的应用，如微视、新闻等，支持视频登录态且支持通用的JSBridge

  var isTenvideoUnion = ua.indexOf('TenvideoUnion') > -1; // 搜狗浏览器极速版

  var isSogouMse = /\sSogouMSE\/(\d[\\.\d]*)/i.test(ua); // 手机QQ浏览器安卓端
  // 1. 一般场景：通过全局变量qb_bridge或者mtt判断
  // 2. 付费SDK场景：通过 MttVideo 标识区分，仅限安卓端

  var isMqbAndroid = isCSR ? false : globalObject.qb_bridge || !!(globalObject.mtt && globalObject.mtt.getBrowserParam) || /MttVideo/i.test(ua);
  var isMqb = !isSogouMse && (isIos ? /mqqbrowser\/(\d+(\.\d+){2,})/gi.test(ua) : isMqbAndroid); // 腾讯新闻

  var isQQNews = /qqnews\/(\d+(\.\d+)*)/i.test(ua);
  var isPCClient = /QQLive\/\d+/.test(ua); // 腾讯体育

  var isQQSports = /qqsports/i.test(ua); // QQ音乐

  var isQQMusic = /\bQQMUSIC\/(\d[\\.\d]*)/i.test(ua) || /QQMUSIC\/(\d[\\.\d]*)/i.test(ua); // 游戏

  var isMsdk = /MSDK\/(\d[\\.\d]*)[a-z]?/.test(ua); // 动漫

  var isAccomic = /QQAC_CLIENT/i.test(ua); // 掌盟

  var isMlol = /lolapp/i.test(ua); // 王者营地

  var isMobaCamps = /smobagamehelper/.test(ua);
  Object.assign(env, {
    isIos: isIos,
    isIphone: isIphone,
    isIpad: isIpad,
    isUNApp: isUNApp,
    isHDApp: isHDApp,
    isAndroid: isAndroid,
    isApad: isApad,
    isMac: isMac,
    isWin: isWin,
    isMqq: isMqq,
    isWechat: isWechat,
    isApp: isApp,
    isKidApp: isKidApp,
    isWetv: isWetv,
    isMqb: isMqb,
    isPCClient: isPCClient,
    isWeb: !isIphone && !isAndroid && !isIpad && !isApad && !/(WebOS|BlackBerry)/.test(ua),
    os: 'other',
    app: 'browser',
    device: 'unknown',
    isLiteApp: isLiteApp,
    isBaseApp: isBaseApp,
    isLocalPkg: isLocalPkg,
    isWeishi: isWeishi,
    isWeChatMiniProgram: isWeChatMiniProgram,
    isTenvideoUnion: isTenvideoUnion,
    isQQNews: isQQNews,
    isQQSports: isQQSports,
    isQQMusic: isQQMusic,
    isMsdk: isMsdk,
    isAccomic: isAccomic,
    isMlol: isMlol,
    isSogouMse: isSogouMse,
    isMobaCamps: isMobaCamps,

    /**
     * Vue SSR环境
     */
    isCSR: isCSR,

    /**
     * 浏览器环境，用于判断在 webview 环境下
     */
    inBrowser: typeof window !== 'undefined',

    /**
     * HoneWeb 客户端预加载环境
     */
    isHoneWeb: typeof HoneWeb !== 'undefined'
  });

  if (env.isIos) {
    env.os = 'ios';
  } else if (env.isAndroid) {
    env.os = 'android';
  } else if (isWin) {
    env.os = 'windows';
  } else if (isMac) {
    env.os = 'mac';
  }

  if (isKidApp) {
    env.app = 'kidapp';
  } else if (isLiteApp) {
    env.app = 'liteapp';
  } else if (isApp) {
    env.app = 'app';
  } else if (isWechat) {
    env.app = 'wechat';
  } else if (isMqq) {
    env.app = 'mqq';
  } else if (isMqb) {
    env.app = 'qqbrowser';
  } else if (isWeishi) {
    env.app = 'weishi';
  } else if (isQQNews) {
    env.app = 'qqnews';
  } else if (isQQSports) {
    env.app = 'qqsports';
  } else if (isQQMusic) {
    env.app = 'qqmusic';
  } else if (isAccomic) {
    env.app = 'accomic';
  } else if (isMlol) {
    env.app = 'mlol';
  } else if (isSogouMse) {
    env.app = 'sogoumse';
  } else if (isMobaCamps) {
    env.app = 'wzyd';
  } // 由于iPad旧UN版本会包含iPhone标识，优化判断iPhone会导致判断不准确


  if (isIpad) {
    env.device = 'ipad';
  } else if (isIphone) {
    env.device = 'iphone';
  } else if (isApad) {
    env.device = 'apad';
  } else if (isAndroid) {
    env.device = 'aphone';
  } else if (isMac) {
    env.device = 'mac';
  } else if (isWin) {
    env.device = 'windows';
  } // 获取系统版本号


  var REG_VERSION = {
    ios: /OS (.*?) like Mac OS/,
    android: /Android (.*?);/i,
    windows: /Windows NT (.*?);/i,
    mac: /\(Macintosh; Intel Mac OS X (.*?)\)/
  };
  var osVersion = (ua.match(REG_VERSION[env.os] || '') || ['', ''])[1];
  env.osVersion = osVersion ? osVersion.replace(/_/g, '.') : ''; // 获取APP版本号

  var REG_APP_VERSION = {
    app: /(?:QQLive|WeTV)(?:HD|Kid)?(?:Browser|_MAC)\/(\d[\\.\d]*)/,
    kidapp: /QQLiveKidBrowser\/(\d[\\.\d]*)/,
    weishi: /WEISHI_(\d[\\.\d]*)/i,
    mqq: /QQ\/(\d[\\.\d]*)/i,
    wechat: /MicroMessenger\/(\d[\\.\d]*)/i,
    qqbrowser: /MQQBrowser\/(\d[\\.\d]*)/i,
    qqnews: /qqnews\/(\d[\\.\d]*)/i,
    qqsports: /(?:com\.tencent\.sportskbs|qqsports_android_ver)\/(\d[\\.\d]*)/i,
    qqmusic: /\sQQMusic\/(\d[\\.\d]*)/i,
    sogoumse: /\sSogouMSE\/(\d[\\.\d]*)/i
  };
  var appVersion = (ua.match(REG_APP_VERSION[env.app] || '') || ['', ''])[1];
  env.appVersion = appVersion ? appVersion.replace(/_/g, '.') : '';
}
init();
export default env;